var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlansCheckCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z",
    fill: "#FBFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7727 6.83313L10.0685 14.574C9.93246 14.7545 9.7296 14.8727 9.50552 14.9022C9.28143 14.9316 9.0549 14.8698 8.87683 14.7306L4.8035 11.474C4.44405 11.1863 4.38585 10.6617 4.6735 10.3023C4.96115 9.94285 5.48572 9.88465 5.84516 10.1723L9.24183 12.8898L14.431 5.8473C14.6012 5.59195 14.8979 5.45078 15.2033 5.47983C15.5088 5.50887 15.7736 5.70344 15.8926 5.98627C16.0116 6.26911 15.9655 6.59445 15.7727 6.83313Z",
    fill: "#FBFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansCheckCircleWhite);
export default __webpack_public_path__ + "static/media/plans_check_circle_white.7b5e9df19b891f33c09ca4c2a036140b.svg";
export { ForwardRef as ReactComponent };